// The browser side of src/lib/signEvent.js: crew / crew_log / crew_leave through api.js (the login's own rights).
import { fetchRows, createRow, updateRow, deleteRow } from './api'
import { undoSignEvent } from './signEvent.js'
export { undoSignEvent }

const gv = v => (v && typeof v === 'object' && 'value' in v ? v.value : v) || ''
const nm = s => String(s || '').trim().toLowerCase()

// the crew_leave rows of this crew member, in the shape planSignEvent() wants
export async function crewPeriodRows(crew) {
  const first = nm(gv(crew['First Name'])), last = nm(gv(crew['Last Name'])), id = gv(crew['Crew ID'])
  const data = await fetchRows('crew_leave')
  return (data || []).filter(l => {
    const ln = nm(gv(l['Crew Name']))
    return (id && gv(l['Crew ID']) === id) || (ln.includes(first) && ln.includes(last))
  }).map(l => ({ id: l.id, type: gv(l['Leave Type']) || 'Leave', start: gv(l['Start Date']), end: gv(l['End Date']), days: Number(l['Days']) || 0 }))
}

export function browserSignIo(crew, onCrew) {
  const name = (gv(crew['First Name']) + ' ' + gv(crew['Last Name'])).trim()
  return {
    async setOnboard(v) { const row = await updateRow('crew', crew.id, { 'Onboard': v }); if (onCrew) onCrew(row) },
    async addLog(l) {
      const row = await createRow('crew_log', { 'Log Entry': l.entry, 'Crew Member': name, 'Crew ID': gv(crew['Crew ID']), 'Action': l.action, 'Date From': l.date, 'Date To': l.dateTo || null, 'Employment Status': l.status || '', 'Port': l.port || '', 'Notes': l.notes || '' })
      return row && row.id
    },
    async patchPeriod(id, p) { await updateRow('crew_leave', id, { 'End Date': p.end || null, 'Days': p.days || 0 }) },
    async addPeriod(p) {
      const row = await createRow('crew_leave', { 'Crew ID': gv(crew['Crew ID']), 'Crew Name': name, 'Leave Type': p.type, 'Start Date': p.start, 'End Date': p.end || null, 'Days': p.days || 0, 'Notes': p.notes || '' })
      return row && row.id
    },
    async removePeriod(id) { await deleteRow('crew_leave', id) },
    async removeLog(id) { await deleteRow('crew_log', id) },
  }
}

// the one call the toggle, the Crew Log form and the Chat action make: -> { done, warn, undo, io }
export async function runSignEvent(crew, ev, onCrew) {
  const { applySignEvent } = await import('./signEvent.js')
  const rows = await crewPeriodRows(crew)
  const io = browserSignIo(crew, onCrew)
  const onboard = crew['Onboard'] === true || crew['Onboard'] === 'true'
  const todayISO = new Date().toISOString().split('T')[0]
  const out = await applySignEvent(io, { ...ev, rows, onboard, todayISO, name: (gv(crew['First Name']) + ' ' + gv(crew['Last Name'])).trim() })
  return { ...out, io }
}
